export const session = [
  {
    path: '/session',
    component: () => import(/* webpackChunkName: "session" */ '@/views/session/Session'),
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBody'),
      },
      {
        path: ':id/edit',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionEditBody'),
      },
      {
        path: ':id/persons',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPersonsBody'),
      },
      {
        path: ':id/presentations',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionPresentationsBody'),
      },
      {
        path: ':id/participations',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionParticipationsBody'),
      },
      {
        path: ':id/sessions',
        component: () => import(/* webpackChunkName: "session" */ '@/views/session/components/SessionSessionsBody'),
      },
    ]
  },
]
